<template>
  <EntityBrowser :mode="mode" />
</template>

<script>
import { defineComponent } from 'vue';
import EntityBrowser from '@/components/browser/EntityBrowser.vue';
import { BrowserMode } from '@/store/modules/entity_browser/config';

export default defineComponent({
  name: 'DocumentBrowser',
  components: {
    EntityBrowser,
  },
  props: {
    mode: {
      type: String,
      default: BrowserMode.DOC,
    },
  },
});
</script>

<style scoped lang='scss'>
</style>
